import Layout from '../components/Layout';
import AboutOwnerSection from '../components/AboutOwnerSection';
import ValuesSection from '../components/ValuesSection';
// import ServicesSection from '../components/ServicesSection';
// import TestimonialsSection from '../components/TestimonialsSection';
import CtaSection from '../components/CtaSection';
import HeroSection from '../components/HeroSection';
import AboutSectionCenter from '../components/AboutSectionCenter';

export default function Home() {
  return (
    <Layout>
      <HeroSection />
      <AboutSectionCenter />
      <AboutOwnerSection />
      <ValuesSection />
      {/* <ServicesSection /> */}
      {/* <TestimonialsSection /> */}
      <CtaSection />
    </Layout>
  );
}
